import React from "react";
import HeroSection from "./components/HeroSection";
import AirdropsSection from "./components/AirdropsSection";
import FeaturesSection from "./components/FeaturesSection";
import AboutBigod from "./components/AboutBigod";
import CoinMarqueeWidget from "./components/CoinMarqueeWidget";

const Home = () => {
  return (
    <main>
      <HeroSection />
      {/* <AboutBigod /> */}

      <AirdropsSection />
      <CoinMarqueeWidget />

      <FeaturesSection />

      <div className="w-full h-screen">
        <img
          src="/tokenanimee.png"
          alt=""
          className="w-full h-full object-cover"
        />
      </div>
    </main>
  );
};

export default Home;
